import { Routes } from '@angular/router';
import { cihazGuard } from '../../guards/cihaz.guard';
import { kartAktifGuard } from './guards/kart-aktif.guard';

export const HMI_PANO_ROUTES: Routes = [
  // Aktivasyon ekranı — guard yok, herkes erişebilir
  {
    path: 'aktivasyon',
    loadComponent: () => import('./aktivasyon/aktivasyon.component').then(m => m.HmiAktivasyonComponent),
    data: { baslik: 'Cihaz Aktivasyonu', simge: '🔑' },
  },
  // Ana HMI pano — cihazGuard ile korumalı
  {
    path: '',
    loadComponent: () => import('./hmi-pano-shell.component').then(m => m.HmiPanoShellComponent),
    data: { baslik: 'HMI Pano', simge: '📟' },
    canActivateChild: [cihazGuard],
    children: [
      { path: '', redirectTo: 'pano', pathMatch: 'full' },
      {
        path: 'pano',
        loadComponent: () => import('./pano/pano.component').then(m => m.HmiPanoPanoComponent),
        data: { baslik: 'Pano Ekranı', simge: '📊' },
        children: [
          {
            path: '',
            loadComponent: () => import('./pano/pages/bosta/bosta.component').then(m => m.HmiPanoBostaComponent),
            data: { baslik: 'Boşta', simge: '📡' },
          },
          {
            path: 'personel',
            loadComponent: () => import('./pano/pages/personel/personel.component').then(m => m.HmiPanoPersonelShellComponent),
            canDeactivate: [kartAktifGuard],
            data: { baslik: 'Personel Paneli', simge: '👤' },
            children: [
              {
                path: '',
                loadComponent: () => import('./dashboard/dashboard.component').then(m => m.HmiDashboardComponent),
                data: { baslik: 'Dashboard', simge: '📊' },
              },
              {
                path: 'ana-sayfa',
                loadComponent: () => import('./pano/pages/personel/pages/ana-sayfa/ana-sayfa.component').then(m => m.HmiPanoPersonelAnaSayfaComponent),
                data: { baslik: 'Ana Sayfa', simge: '🏠' },
              },
              {
                path: 'puantaj',
                loadComponent: () => import('./pano/pages/personel/pages/puantaj/puantaj.component').then(m => m.HmiPuantajComponent),
                data: { baslik: 'Puantaj', simge: '⏱️' },
              },
              {
                path: 'pdks',
                loadComponent: () => import('./pano/pages/personel/pages/puantaj/puantaj.component').then(m => m.HmiPuantajComponent),
                data: { baslik: 'PDKS', simge: '⏱️' },
              },
              {
                path: 'rapor',
                loadComponent: () => import('./pano/pages/personel/pages/pdks/pdks-aylik-ozet.component').then(m => m.PdksAylikOzetComponent),
                data: { baslik: 'PDKS Rapor', simge: '📊' },
              },
              {
                path: 'yonetim',
                loadComponent: () => import('./pano/pages/personel/pages/yonetim/personel.component').then(m => m.HmiPanoPersonelComponent),
                data: { baslik: 'Personel Yönetimi', simge: '👥' },
              },
              {
                path: 'projeler',
                loadComponent: () => import('./pano/pages/personel/pages/projeler/projeler.component').then(m => m.HmiPanoProjelerComponent),
                data: { baslik: 'Projeler', simge: '📁' },
                children: [
                  { path: '', redirectTo: 'ana-sayfa', pathMatch: 'full' },
                  {
                    path: 'ana-sayfa',
                    loadComponent: () => import('./pano/pages/personel/pages/projeler/pages/ana-sayfa/ana-sayfa.component').then(m => m.HmiProjelerAnaSayfaComponent),
                    data: { baslik: 'Projeler Ana Sayfa', simge: '📋' },
                  },
                  {
                    path: 'pano',
                    loadComponent: () => import('./pano/pages/personel/pages/projeler/pages/pano/pano.component').then(m => m.HmiProjelerPanoComponent),
                    data: { baslik: 'Proje Panosu', simge: '📊' },
                  },
                ],
              },
              {
                path: 'uretim',
                loadComponent: () => import('./pano/pages/personel/pages/uretim/uretim.component').then(m => m.HmiPanoUretimComponent),
                data: { baslik: 'Üretim', simge: '⚙️' },
                children: [
                  { path: '', redirectTo: 'ana-sayfa', pathMatch: 'full' },
                  {
                    path: 'ana-sayfa',
                    loadComponent: () => import('./pano/pages/personel/pages/uretim/pages/ana-sayfa/ana-sayfa.component').then(m => m.HmiUretimAnaSayfaComponent),
                    data: { baslik: 'Üretim Ana Sayfa', simge: '⚙️' },
                  },
                ],
              },
              {
                path: 'satis',
                loadComponent: () => import('./pano/pages/personel/pages/satis/satis.component').then(m => m.HmiPanoSatisComponent),
                data: { baslik: 'Satış', simge: '🛒' },
                children: [
                  { path: '', redirectTo: 'ana-sayfa', pathMatch: 'full' },
                  {
                    path: 'ana-sayfa',
                    loadComponent: () => import('./pano/pages/personel/pages/satis/pages/ana-sayfa/ana-sayfa.component').then(m => m.HmiSatisAnaSayfaComponent),
                    data: { baslik: 'Satış Ana Sayfa', simge: '🛒' },
                  },
                ],
              },
              {
                path: 'yonetim-kayit',
                loadComponent: () => import('./pano/pages/personel/pages/yonetim-kayit/yonetim-kayit.component').then(m => m.HmiPanoYonetimKayitComponent),
                data: { baslik: 'Yönetim', simge: '🏢' },
                children: [
                  { path: '', redirectTo: 'ana-sayfa', pathMatch: 'full' },
                  {
                    path: 'ana-sayfa',
                    loadComponent: () => import('./pano/pages/personel/pages/yonetim-kayit/pages/ana-sayfa/ana-sayfa.component').then(m => m.HmiYonetimAnaSayfaComponent),
                    data: { baslik: 'Yönetim Ana Sayfa', simge: '🏢' },
                  },
                ],
              },
              {
                path: 'posta',
                loadComponent: () => import('./pano/pages/personel/pages/posta/posta.component').then(m => m.HmiPostaComponent),
                data: { baslik: 'Posta', simge: '📧' },
              },
              {
                path: 'widget-editor/:widgetId',
                loadComponent: () => import('@fikoyt-ui/paylasim-sistemi/fiko-tasarim-editoru/fiko-tasarim-editoru.component').then(m => m.FikoTasarimEditoruComponent),
                data: { baslik: 'Widget Düzenle', simge: '🎨' },
              },
            ],
          },
          {
            path: 'yetkisiz',
            loadComponent: () => import('./pano/pages/yetkisiz/yetkisiz.component').then(m => m.HmiPanoYetkisizComponent),
            data: { baslik: 'Yetkisiz Erişim', simge: '🚫' },
          },
          {
            path: 'yukleniyor',
            loadComponent: () => import('./pano/pages/yukleniyor/yukleniyor.component').then(m => m.HmiPanoYukleniyorComponent),
            data: { baslik: 'Yükleniyor', simge: '⏳' },
          },
        ],
      },
      {
        path: 'ayarlar',
        loadComponent: () => import('./ayarlar/ayarlar.component').then(m => m.HmiPanoAyarlarComponent),
        data: { baslik: 'Cihaz Ayarları', simge: '⚙️' },
      },
    ],
  },
];
